import { render, staticRenderFns } from "./ContractList.vue?vue&type=template&id=2f4c13c0&scoped=true&"
import script from "./ContractList.vue?vue&type=script&lang=js&"
export * from "./ContractList.vue?vue&type=script&lang=js&"
import style0 from "./ContractList.vue?vue&type=style&index=0&id=2f4c13c0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4c13c0",
  null
  
)

export default component.exports